<template>
  <a-layout>
    <!--中间布局 background: '#fff', -->
    <a-layout-content class="center-container"
      :style="{ padding: '75px 50px 20px 50px', margin: 0, minHeight: '720px' }">

      <!-- 登录卡片 -->
      <a-card title="用户登录" :hoverable="false" :bordered="true" style="width: 520px;" :bodyStyle="{ padding: '25px' }"
        :type="'inner'" class="card">
        <a-form :model="loginUser" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <a-form-item label="登录名">
            <a-input v-model:value="loginUser.loginName" :allowClear="true" placeholder="请输入用户名" />
          </a-form-item>
          <a-form-item label="密码">
            <a-input v-model:value="loginUser.password" type="password" :allowClear="true" placeholder="请输入密码" />
          </a-form-item>
          <a-form-item label="验证码">
            <a-input v-model:value="loginUser.captcha" :allowClear="true" placeholder="请输入验证码" />
            <a-image :width="160" :src="loginUser.base64" :placeholder="true" :preview="false"
              style="border: 1px solid #EBEEF5;cursor: pointer;margin-top: 5px;" @click="pullCaptcha" />
            <!-- 加载状态 -->
            <a-spin :spinning="loadingCaptcha" />
          </a-form-item>
          <a-form-item>
            <a-button type="primary" style="width: 100px;margin-left: 185px;" @click="login">登 录</a-button>
          </a-form-item>
        </a-form>
      </a-card>

    </a-layout-content>
    <!-- 底部 -->
    <the-footer></the-footer>
  </a-layout>

</template>
<script lang="ts">
import { defineComponent, onMounted, ref, computed } from 'vue';
import TheFooter from "@/components/the-footer.vue";
import axios from 'axios';
import { message } from 'ant-design-vue';
import store from "@/store";
import useRouter from '@/router'

// 引用public/js/md5.js 
declare let hexMd5: any;
declare let KEY: any;

export default defineComponent({
  name: 'Login',
  components: {
    TheFooter
  },
  setup() {

    // 登录后保存
    const user = computed(() => store.state.user);

    // 用来登录
    const loginUser: any = ref({});

    // 加载状态
    const loadingCaptcha = ref(false)

    // 拉取验证码
    const pullCaptcha = () => {
      loadingCaptcha.value = true
      axios.get('/captcha/base64').then((response) => {
        loadingCaptcha.value = false
        const result = response.data;
        console.log('captcha', result)
        if (result.code == 0 && result.message == 'success') {
          // 修改验证码图片
          //loginUser.value.captcha = result.data.captcha
          loginUser.value.key = result.data.key
          loginUser.value.base64 = result.data.base64
        } else {
          message.error(result.message);
        }
      });

    };

    // 登录
    const login = () => {
      console.log("开始登录...");
      // 校验用户名 & 密码
      if (loginUser.value.password == undefined || loginUser.value.password == undefined
        || loginUser.value.password.trim() == '' || loginUser.value.password.trim() == ''
        || loginUser.value.captcha == undefined || loginUser.value.captcha.trim() == ''
      ) {
        message.warning('请补全数据')
        return
      }

      // 密码MD5加密
      console.log("KEY => ", KEY);
      console.log("password => ", hexMd5(loginUser.value.password));
      console.log("password + KEY => ", hexMd5(loginUser.value.password + KEY));

      console.log("loginUser => ", loginUser.value);

      loginUser.value.password = hexMd5(loginUser.value.password + KEY);
      axios.post('/user/login', loginUser.value).then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          message.success("登录成功！");
          store.commit("setUser", result.data.user);
          // 跳转到首页
          useRouter.push({ path: '/' })
        } else {
          message.error(result.message);
        }
      });
    };


    /**
     * 获取当前的路由
     */
    onMounted(() => {
      console.log('login user => ', user)
      if (user.value.id != undefined) {
        // 跳转到首页
        useRouter.push({ path: '/' })
      }

      // 显示默认图片
      // loginUser.value.base64 = 'data:image/png;base64,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'

      // 拉取验证码
      pullCaptcha()

    });

    return {
      loginUser,
      user,
      pullCaptcha,
      login,
      loadingCaptcha
    }
  }
});
</script>
<style scoped>
.center-container {
  display: flex;
  /* 水平居中 */
  justify-content: center;
  /* 垂直居中 */
  align-items: center;
}
</style>
